import styled from 'styled-components';

import {getColor} from '@yourcoach/shared/styles/utils';
import {View} from '@yourcoach/shared/uikit/View';

const Container = styled(View)`
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(auto-fit, 1fr);
  grid-auto-flow: column;
  justify-content: start;
  min-width: 0;
`;

const Cell = styled(View)`
  gap: 10px;
  min-width: 0;

  &::before {
    content: '•';
    color: ${getColor('text3')};
  }

  &:nth-child(1) {
    &::before {
      display: none;
    }
  }
`;

export const Layout = {
  Cell,
  Container,
};
